import { useFeature as useOptimizelyFeature } from '@optimizely/react-sdk';

export const useFeature = featureKey => {
  const [enabled, variables] = useOptimizelyFeature(featureKey, {
    autoUpdate: true,
  });

  return { enabled, variables };
};
